/*
 *
 * actions
 *
 */

import {

LOAD_CITY,
LOAD_CITY_SUCCESS,
LOAD_CITY_ERROR,
LOAD_STATE,
LOAD_STATE_SUCCESS,
LOAD_STATE_ERROR,
LOAD_COUNTRY,
LOAD_COUNTRY_SUCCESS,
LOAD_COUNTRY_ERROR,

} from "./constants";

//loadCity
export function loadCity(searchFilter) {
    return {
        type: LOAD_CITY,
        searchFilter
    }
}

export function loadCitySuccess(cityList, success) {
    return {
        type: LOAD_CITY_SUCCESS,
        cityList,
        success,
    }
}

export function loadCityError(error) {
    return {
        type: LOAD_CITY_ERROR,
        error
    }
}



//loadLopSetting
export function loadState(searchFilter) {
    return {
        type: LOAD_STATE,
        searchFilter
    }
}

export function loadStateSuccess(stateList, success) {
    return {
        type: LOAD_STATE_SUCCESS,
        stateList,
        success,
    }
}

export function loadStateError(error) {
    return {
        type: LOAD_STATE_ERROR,
        error
    }
}


//loadCountry
export function loadCountry(searchFilter) {
    return {
        type: LOAD_COUNTRY,
        searchFilter
    }
}

export function loadCountrySuccess(countryList, success) {
    return {
        type: LOAD_COUNTRY_SUCCESS,
        countryList,
        success,
    }
}

export function loadCountryError(error) {
    return {
        type: LOAD_COUNTRY_ERROR,
        error
    }
}

const actions = {
    loadCity,
    loadCitySuccess,
    loadCityError,
    loadState,
    loadStateSuccess,
    loadStateError,
    loadCountry,
    loadCountrySuccess,
    loadCountryError

}


export default actions;